import * as c from "@yahshi/contracts";
import { createAdminRequest, type AdminHttpOptions } from "../../../lib/adminHttp";

export interface ContentConsentApi {
  history(id:string, query?: {page?:number;pageSize?:number}): Promise<c.ContentConsentHistory>;
  list(query?: Partial<c.AdminContentConsentListQuery>): Promise<c.AdminContentConsentListResult>;
}

const qs = (value: object) => new URLSearchParams(Object.entries(value).map(([key, item]) => [key, String(item)])).toString();

export function createHttpContentConsentApi(options: AdminHttpOptions): ContentConsentApi {
  const request = createAdminRequest(options);
  return {
    history: (id, query = {}) => request(`/admin/content-consents/${encodeURIComponent(id)}?${qs(c.contentConsentHistoryQuerySchema.parse(query))}`, c.contentConsentHistorySchema),
    list: (query = {}) => request(`/admin/content-consents?${qs(c.adminContentConsentListQuerySchema.parse(query))}`, c.adminContentConsentListResultSchema),
  };
}
